import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Badge, Grid, Typography } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { BOOKING_STATUS, USER_ROLES } from 'src/config/enum';
import { notification } from 'src/redux/features/auth/actions';
const NotificationMenuPopover = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { notificationCount, user } = useSelector((state) => state.auth);
  useEffect(() => {
    if (user?.role === USER_ROLES.ADMIN) {
      dispatch(notification({ status: BOOKING_STATUS.PENDING_REVIEW }));
    } else {
      dispatch(notification({ status: BOOKING_STATUS.IN_PROGRESS, driverId: user._id }));
    }
    // eslint-disable-next-line
  }, []);

  return (
    <Grid
      mx={1}
      sx={{ cursor: 'pointer' }}
      onClick={() => navigate('/booking', { state: { status: 'pending-review' } })}
    >
      <Badge
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        badgeContent={notificationCount?.toString()}
        color="info"
      >
        <Typography variant="h6" color={'primary'}>
          {user.role === USER_ROLES.ADMIN ? 'PR' : 'UJ'}
        </Typography>
      </Badge>
    </Grid>
  );
};

export default NotificationMenuPopover;
